import React, { useState } from "react";
import BackDrop from "../../../components/ui/BackDrop";

import { closeIcon, fileUploadIcon } from "../../../assetData/icons";
import { spinnerAnim } from "../../../assetData/loaders";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterScriptImport = ({ setIsImport, handleImportScript, isLoading, isButtonClicked }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const onClose = () => {
    setIsImport(false);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const res = await handleImportScript(formData);
      if (res.status_code === 200) {
      }
    }
  };

  return (
    <>
      <div
        className={`fixed left-1/2 top-1/2 z-50 mx-auto min-h-[300px] w-[500px] max-w-[1200px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8`}
      >
        <h2 className="pb-4 text-center text-2xl font-bold text-neutral-800">
          Import Scrip
        </h2>
        {isLoading && (
          <div className="absolute left-[40%] z-[1000] h-[300px] w-[200px]">
            <img src={spinnerAnim} className="w-[100px]" alt="" />
          </div>
        )}

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <div className="mt-8 flex gap-2 ">
          <div className="w-full space-y-4">
            <div className="relative cursor-pointer overflow-hidden rounded-lg bg-gray-100 ">
              <input
                type="file"
                className="custom-doc-uploader text-neutral-600"
                onChange={handleFileChange}
              />
              <img
                src={fileUploadIcon}
                className="absolute left-4 top-1/2 z-10 -translate-y-1/2"
              />
            </div>

            <button
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
              onClick={handleFileUpload}
            >
              {isButtonClicked ? <MirageLoader /> : "IMPORT"}
            </button>
          </div>
        </div>
      </div>
      <BackDrop />
    </>
  );
};

export default MasterScriptImport;
